import React from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import cx from 'classnames'
import TitledContent from 'components/TitledContent/TitledContent'
import Income from 'components/Income/Income'
import NoData from 'components/NoData/NoData'
import messages from './messages'
import styles from './RentalsItemAnalytics.scss'

const fieldsPerType = {
  host: ['documentedIncomeForHost', 'reportedIncomeForHost', 'reportedLastYear', 'taxRate', 'taxGapForHost'],
  listing: ['documentedIncome', 'reportedIncome', 'occupancyTaxRate', 'taxGap'],
} as const

type ItemType = keyof typeof fieldsPerType

interface RentalsItemAnalyticsProps extends InjectedIntlProps {
  isSpaced?: boolean
  type: ItemType
  item: {
    totalRevenue?: number
    [key: string]: any
  }
}

const RentalsItemAnalytics = ({ intl, isSpaced = false, type, item }: RentalsItemAnalyticsProps) => (
  <div className={styles.container}>
    <ul className={styles.fields}>
      {fieldsPerType[type].map(key => (
        <li key={key} className={cx(styles.field, { [styles.spaced]: isSpaced })}>
          <TitledContent
            title={intl.formatMessage((messages.fields as any)[key])}
            titleClassName={styles.title}
            contentClassName={styles.content}
          >
            {key !== 'documentedIncomeForHost' ? (
              <NoData />
            ) : (
              <Income isFormatted={false} value={item.totalRevenue || 0} useCurrencyConversion={true} />
            )}
          </TitledContent>
        </li>
      ))}
    </ul>
  </div>
)

export default injectIntl(RentalsItemAnalytics)

